// extracted by mini-css-extract-plugin
module.exports = {"liveBox":"style_liveBox__Nrxgp","date":"style_date__sf_tZ","iconBox":"style_iconBox__7a9Cc","icon":"style_icon__Mkk6M","commentBtn":"style_commentBtn__j4kug"};